import type { pedalType, pedalFilters } from '@/types/pedal'
import axios from 'axios'

export default class {
  static async fetchPedals({
    sessionId = undefined,
    filters = undefined,
  }: {
    sessionId?: string
    filters?: pedalFilters
  } = {}) {
    return axios.post<pedalType>('Hardware/RetrievePedals', {
      sessionId: sessionId,
      ...filters,
    })
  }

  static async fetchAveragePedal({
    sessionId = undefined,
  }: {
    sessionId?: string
  } = {}): Promise<pedalType> {
    const { data } = await this.fetchPedals({
      sessionId: sessionId,
      filters: { FreeTextSearch: '(average)' },
    })
    return data.Pedals[0] ?? undefined
  }
}
